module.exports = __webpack_public_path__ + "img/ecommerce.333aae34.png";